import React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { useAppState } from '../../overmind';
import { PagePath } from '../navigation.enums';
import { YourCareerPage } from '../../pages/your-career/your-career.page';

export function YourCareerRouter(): JSX.Element {
  const { user } = useAppState();

  return (
    <Routes>
      <Route path={PagePath.yourCareerRole} element={<YourCareerPage />} />

      <Route path={PagePath.root} element={<Navigate to={`${PagePath.yourCareerBase}${PagePath.yourCareerRole.replace(':roleSlug', user!.jobRoles[0].slug)}`} />} />
    </Routes>
  );
}
